import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import { getAnalytics } from "firebase/analytics";
import { configureStore } from "@reduxjs/toolkit";
import { appMain, reCAPTCHA as mainCap } from "config/keys/main";
import { appUser, reCAPTCHA as userCap } from "config/keys/user";
import rootReducers from "./store/root.reducer";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "./css/common.css";
import "./css/concept.css";
import "./css/fitness_virtual.css";
import "./css/fitness_benefit.css";
import "./css/three_click.css";
import "./css/component.css";
import "./css/vote.css";
import "./index.css";

if (window.location.hostname === "localhost") {
  window.self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

initializeAppCheck(appMain, {
  provider: new ReCaptchaEnterpriseProvider(mainCap),
  isTokenAutoRefreshEnabled: true,
});

initializeAppCheck(appUser, {
  provider: new ReCaptchaEnterpriseProvider(userCap),
  isTokenAutoRefreshEnabled: true,
});

getAnalytics(appMain);

const store = configureStore({
  reducer: rootReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

if (process.env.NODE_ENV !== "development") {
  console.log = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
